import { useStaticQuery, graphql } from "gatsby"

import { DEFAULT_STOREFRONT } from "../cart/constants"
import { selectSdkBundle } from "../utils/V2/consolidateItem"

import { useCallback } from "react"

export const useGetBundles = (): {
  allBundle: { edges: { node: YocoCom.SdkBundle }[] }
} => {
  const bundles = useStaticQuery(graphql`
    query Bundles {
      allBundle {
        edges {
          node {
            id
            externalId
            bundle_code
            name
            short_name
            description
            short_description
            image
            unit_price_formatted
            unit_price_currency
            unit_price
            original_unit_price
            is_discounted
            type
            is_listed_in_catalogue
            max_quantity_per_cart
            tax_policy
            tax_rate
            ribbon_text
            ribbon_class
            storefronts
            reason_not_available
            sdkIndex
            content_skus
          }
        }
      }
    }
  `)

  return bundles
}

export const useGetBundleByCode = (): ((
  code: string,
  storefront?: string
) => YocoCom.SdkBundle | null) => {
  const bundles = useGetBundles()

  const getBundleByCode = useCallback(
    (code: string, storefront = DEFAULT_STOREFRONT) =>
      selectSdkBundle(
        bundles.allBundle.edges.map((bundle) => bundle.node),
        code,
        storefront
      ) ?? null,
    [bundles]
  )

  return getBundleByCode
}
